import { CACHE_STORAGE_KEY } from 'config/constants'

export default class CacheApiUtil {
  static deleteCache() {
    window?.caches?.delete(CACHE_STORAGE_KEY)
  }
}
